export const LocationIcon: React.FC<any> = ({ className }) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="inherit">
        <g opacity="1" clip-path="url(#clip0_2442_598)">
            <path d="M10.9616 22.1946L10.3226 21.6469C9.44171 20.9093 1.75 14.2665 1.75 9.4074C1.75 4.31998 5.87418 0.195801 10.9616 0.195801C16.049 0.195801 20.1732 4.31998 20.1732 9.4074C20.1732 14.2665 12.4815 20.9094 11.6042 21.6506L10.9616 22.1946ZM10.9616 2.18762C6.97612 2.19213 3.74637 5.42188 3.74186 9.40736C3.74186 12.4599 8.47409 17.3364 10.9616 19.5683C13.4491 17.3355 18.1813 12.4562 18.1813 9.40736C18.1768 5.42188 14.9471 2.19217 10.9616 2.18762Z" fill="inherit"/>
            <path d="M10.9617 13.0587C8.94509 13.0587 7.3103 11.4239 7.3103 9.40726C7.3103 7.39065 8.94509 5.75586 10.9617 5.75586C12.9783 5.75586 14.6131 7.39065 14.6131 9.40726C14.6131 11.4239 12.9784 13.0587 10.9617 13.0587ZM10.9617 7.58152C9.9534 7.58152 9.136 8.39891 9.136 9.40722C9.136 10.4155 9.9534 11.2329 10.9617 11.2329C11.97 11.2329 12.7874 10.4155 12.7874 9.40722C12.7874 8.39891 11.97 7.58152 10.9617 7.58152Z" fill="inherit"/>
        </g>
        <defs>
            <clipPath id="clip0_2442_598">
            <rect width="22" height="22" fill="white" transform="translate(0 0.1875)"/>
            </clipPath>
        </defs>
        </svg>
    `,
      }}
    />
  );
};
